import { render } from "./CoursesDetailsPage.vue?vue&type=template&id=2b343e25&scoped=true&ts=true"
import script from "./CoursesDetailsPage.vue?vue&type=script&lang=ts"
export * from "./CoursesDetailsPage.vue?vue&type=script&lang=ts"

import "./CoursesDetailsPage.vue?vue&type=style&index=0&id=2b343e25&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b343e25"]])

export default __exports__